import { featureFlag } from '@/services/featureFlagProvider'
import { IFeatureFlag } from '@sennder/senn-node-microfrontend-interfaces'
import { ref, onUnmounted } from 'vue'

export const useFeatureFlag = <Flag extends IFeatureFlag = boolean>(
  name: string
) => {
  const flag = ref<Flag>()

  const stopWatching = featureFlag.watchFeatureFlag<Flag>(name, (value) => {
    flag.value = value
  })

  onUnmounted(stopWatching)

  return flag
}
